import React, { Fragment, useEffect, useState } from "react";
import "./Account.css";
// import MetaData from '../../layout/MetaData';
import { useSelector } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import GradientAddressIcon from "../../layout/Gradient icons/AddressIcon";
import GradientFaqIcon from "../../layout/Gradient icons/FAQIcon";
import GradientFavouritesIcon from "../../layout/Gradient icons/FavoritesIcon";
import GradientNotificationIcon from "../../layout/Gradient icons/NotificationIcon";
import GradientOrderIcon from "../../layout/Gradient icons/OrderIcon";
import GradientPrivacyIcon from "../../layout/Gradient icons/PrivacyIcon";
import GradientRewardsIcon from "../../layout/Gradient icons/RewardsIcon";



function Account() {
  const currentUser = useSelector((state) => state.currentUser);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Assuming 768px as the mobile breakpoint

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

console.log(currentUser);
  // const [click, setClick] = useState(false);
  // const [toggleState, setToggleState] = useState(1);
  // const toggleTab = (index) => {
  //   setToggleState(index);
  // }

  // const handleClick = () => setClick(!click);
  return (
    <Fragment>
        <div className="w-full px-auto mt-[70px] h-fit min-h-[100dvh]">
          <div className="w-full">
          <div className="w-full min-h-[100dvh] flex relative">
  {/* Left Section with Gradient Patches */}
  <div className="acc_left_sec relative w-1/4 p-4 rounded-xl border backdrop-blur-lg bg-white/10 before:absolute before:w-2/3 before:h-2/3 before:bg-gradient-to-br before:from-purple-500 before:via-pink-500 before:to-blue-500 before:opacity-30 before:blur-2xl before:top-1/4 before:left-1/4 before:rounded-full">
    <NavLink className="user_info_bx border rounded-xl p-4 bg-white/20 backdrop-blur-md" to='/account/your-profile'>
      <div className="acc_nav_profile_group">
        <span></span>
        <p>Kamal Biswal</p>
      </div>
    </NavLink>
    <div className="nav_group border rounded-xl bg-white/20 backdrop-blur-md relative p-4">
      <nav className="acc_nav_btns_group bg-transparent">
        <NavLink to='/account/your-orders'>
          <span className="nav_icon"><GradientOrderIcon/></span><span>Orders</span>
        </NavLink>
      </nav>
      <nav className="acc_nav_btns_group bg-transparent">
        <NavLink to='/account/addresses'>
          <span className="nav_icon"><GradientAddressIcon/></span><span>Addresses</span>
        </NavLink>
        <NavLink to='/notifications'>
          <span className="nav_icon"><GradientNotificationIcon/></span><span>Your Notifications</span>
        </NavLink>
        <NavLink to='/account/wishlists'>
          <span className="nav_icon"><GradientFavouritesIcon/></span><span>Wishlist</span>
        </NavLink>
      </nav>
      <nav className="acc_nav_btns_group bg-transparent">
        <NavLink to='/account/coupons'>
          <span className="nav_icon"><GradientRewardsIcon/></span><span>Coupons</span>
        </NavLink>
      </nav>
      <nav className="acc_nav_btns_group bg-transparent">
        <NavLink to='/account/savedcards'>
          <span className="nav_icon"><GradientFaqIcon/></span><span>FAQ</span>
        </NavLink>
        <NavLink to='/account/savedUPIs'>
          <span className="nav_icon"><GradientPrivacyIcon/></span><span>Security & Privacy</span>
        </NavLink>
      </nav>
    </div>
  </div>

  {/* Right Section with Gradient Patches */}
  <div className="acc_right_sec flex-1 relative p-6 rounded-xl border backdrop-blur-lg bg-white/10">
  {/* Gradient Patch 1 */}
  <div className="absolute w-32 h-32 bg-gradient-to-br from-indigo-500 via-blue-500 to-teal-500 opacity-30 blur-2xl rounded-full top-10 left-10"></div>

  {/* Gradient Patch 2 */}
  <div className="absolute w-2 h-52 bg-gradient-to-br from-purple-500 via-pink-500 to-red-500 opacity-30 blur-2xl rounded-full top-52 right-50"></div>

  {/* Gradient Patch 3 */}
  <div className="absolute w-72 h-72 bg-gradient-to-br from-blue-200 via-purple-500 to-pink-500 opacity-20 blur-2xl rounded-full top-32 left-1/5"></div>

  <Outlet />
</div>

</div>

      </div>
        </div>
      
      
    </Fragment>
  );
}

export default Account;